import {Backdrop, Button, createStyles, Fade, makeStyles, Modal, Theme} from "@material-ui/core";
import React, {useEffect, useState}                                     from "react";

import {Asset, Instrument, MarketWidgetIdentifier} from "../../../../api/api";
import {AutocompleteClientTradableInstruments}     from "../../../../components/autocomplete/AutocompleteClientTradableInstruments";
import {string} from "yup";

export interface AddMarketWidgetModalProps {
  open                      : boolean
  setOpen                   : any
  marketWidgets             : MarketWidgetIdentifier[] | undefined
  setMarketWidgets          : any
  tradableAssets            : Asset[] | undefined
  clientTradableInstruments : Instrument[] | undefined
  assetIdMap                : {[assetId: number]: Asset} | undefined
}

const AddMarketWidgetModalStyles = makeStyles((theme: Theme) =>
    createStyles({
      modal                 : {
        margin          : 'auto',
        alignItems      : 'center',
        justifyContent  : 'center',
        maxHeight       : '50vh',
        maxWidth        : '50vw',
        overflowY       : 'auto'
      },
      paper                 : {
        backgroundColor : theme.palette.background.paper,
        border          : '2px solid #000',
        boxShadow       : theme.shadows[5],
        padding         : theme.spacing(2, 4, 3),
      },
      instrumentButton      : {
        width     : '50%',
        textAlign : 'center',
        fontSize  : 'large'
      },
      modalButtonContainer  : {
        marginTop       : '1rem',
        display         : 'flex',
        flexDirection   : 'row',
        justifyContent  : 'center',
        alignItems      : 'center'
      },
      cancelButton          : {
        display     : 'flex',
        marginLeft  : '1rem'
      },
      submitButton          : {
        display     : 'flex',
        marginLeft  : 'auto'
      },
    }),
)

export const AddMarketWidgetModal = React.memo((p: AddMarketWidgetModalProps) => {
  const [ marketWidgetInstrumentIDs, setMarketWidgetInstrumentIDs ] = useState<Set<number>>(new Set()),
        [ selectedInstrument, setSelectedInstrument ]               = useState<Instrument>();

  const classes = AddMarketWidgetModalStyles();

  const handleClose = () => {
    p.setOpen(false);
    setSelectedInstrument(undefined);
  }

  const handleSubmit = () => {
    if (p.assetIdMap && selectedInstrument) {
      const newMarketWidgets    = Array.from(p.marketWidgets || []),
            contraAssetId       = selectedInstrument.contraAssetId!,
            quoteCurrencyTicker = p.assetIdMap[selectedInstrument.quoteCurrencyId]?.ticker,
            baseAssetTicker     = p.assetIdMap[selectedInstrument.assetId]?.ticker,
            ticker:     string  = selectedInstrument.ticker !== undefined ? selectedInstrument.ticker! : (selectedInstrument.contraAssetId !== undefined && selectedInstrument.contraAssetId !== 0) ? (p.assetIdMap[selectedInstrument.assetId]?.ticker + '/' + p.assetIdMap[contraAssetId]?.ticker) : p.assetIdMap[selectedInstrument.assetId]?.ticker,
            qtyTicker:  string  = selectedInstrument.qtyInQuoteAsset !== undefined && selectedInstrument.qtyInQuoteAsset! ? quoteCurrencyTicker : ticker

      newMarketWidgets.splice(-1, 0, {instrumentID: selectedInstrument.instrumentId,
                                                            baseAssetTicker: baseAssetTicker,
                                                            quantityAssetTicker: qtyTicker,
                                                            quoteCurrencyTicker:quoteCurrencyTicker,
                                                            instrumentTicker: ticker});
      p.setMarketWidgets(newMarketWidgets);
      p.setOpen(false);
      setSelectedInstrument(undefined)
    }
  }

  useEffect(() => {
    if (p.marketWidgets !== undefined) {
      setMarketWidgetInstrumentIDs(() => new Set(p.marketWidgets?.map((marketWidget: MarketWidgetIdentifier) => {return marketWidget.instrumentID})));
    }
  }, [p.marketWidgets])

  return (
    <Modal
      aria-labelledby="add-new-market-instrument"
      aria-describedby="add-new-market-instrument-description"
      className={classes.modal}
      open={p.open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
    >
      <Fade in={p.open}>
        <div className={classes.paper}>
          <h2 id="add-new-market-instrument">Select Instrument:</h2>
          <p id="add-new-market-instrument-description" hidden>Select an instrument to trade from the searchable dropdown</p>
          <AutocompleteClientTradableInstruments
            value={selectedInstrument ? selectedInstrument : null}
            clientTradableInstruments={p.clientTradableInstruments}
            hiddenInstrumentIDs={marketWidgetInstrumentIDs}
            onChange={(i: Instrument | null) => {setSelectedInstrument(i ? {...i} : undefined)}}/>
          <div className={classes.modalButtonContainer}>
            <Button
              aria-label="submit"
              variant="contained"
              className={classes.submitButton}
              color='primary'
              onClick={handleSubmit}>Submit</Button>
            <Button
              aria-label="cancel"
              variant="contained"
              className={classes.cancelButton}
              color='secondary'
              onClick={handleClose}>Cancel</Button>
           </div>
        </div>
      </Fade>
    </Modal>
  )
}, (prevProps: AddMarketWidgetModalProps, newProps: AddMarketWidgetModalProps) => {
  if( prevProps.marketWidgets === newProps.marketWidgets && prevProps.open === newProps.open ) {
    return true;
  } else {
    return false;
  }
})